import { useRichTextEditorContext } from '../hooks/useRichTextEditorContext';
import { Indicator } from './Indicator';

export const RichTextIndicator = () => {
  const { editor, characterLimit } = useRichTextEditorContext();
  if (!characterLimit) return null;

  const chracterCount = editor?.storage.characterCount.characters() ?? 0;
  return (
    <div className="grid grid-cols-[24px]">
      <Indicator
        percent={chracterCount / characterLimit}
        percentWarnLimit={0.9}
      />
    </div>
  );
};
